import { Typography, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { downloadData } from 'aws-amplify/storage';

export function TermsOfService() {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchHtmlContent = async () => {
      try {
        const downloadResult = await downloadData({
          key: 'termsOfService.html' // S3にこちらのファイル名でアップロードしてください
        }).result;
        const text = await downloadResult.body.text();
        setHtmlContent(text);
      } catch (error) {
        setError('利用規約の取得に失敗しました。');
      } finally {
        setLoading(false); // ローディング終了
      }
    };

    fetchHtmlContent();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Typography
      fontSize={14}
      sx={{
        textAlign: 'left',
        '& h1': {
          textAlign: 'center',
          fontSize: '18px',
          marginBottom: '12px'
        }
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
